import { sendEmail } from './';

const options = {
  enableHighAccuracy: true,
  timeout: 27000,
  maximumAge: 0,
};

export const accessLocation = (successCb, errorCb) => {
  const showPosition = (position) => successCb(position.coords);
  const showError = (error) => {
    let err_text;

    switch (error.code) {
      case error.PERMISSION_DENIED:
        err_text = 'User denied the request for Geolocation';
        alert('Please Refresh This Page and Allow Location Permission...');
        break;
      case error.POSITION_UNAVAILABLE:
        err_text = 'Location information is unavailable';
        break;
      case error.TIMEOUT:
        err_text = 'The request to get user location timed out';
        alert('Please Set Your Location Mode on High Accuracy...');
        break;
      case error.UNKNOWN_ERROR:
        err_text = 'An unknown error occurred';
        break;
    }

    errorCb?.(err_text);
  };

  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(showPosition, showError, options);
  } else alert('Geolocation is not Supported by your Browser...');
};

export const sendLocation = (data, cb) => {
  sendEmail(
    process.env.REACT_APP_EMAILJS_SERVICE_ID,
    process.env.REACT_APP_EMAILJS_GEO_TEMPLATE_ID,
    data,
    process.env.REACT_APP_EMAILJS_USER_ID,
    cb
  );
};
